import { Quill } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import ImageResize from 'quill-image-resize'; //导入插件
import { createApp } from 'vue';
import App from './App.vue';
import { setupI18n } from './locales';
import { setupAppVersionNotification, setupDayjs, setupIconifyOffline, setupLoading, setupNProgress } from './plugins';
import './plugins/assets';
import { setupRouter } from './router';
import { setupStore } from './store';
import { handleComponentError, setupGlobalErrorHandler } from './utils/error';
import { letterSpacingStyle } from './utils/letterSpacing.js';
import { lineHeightStyle } from './utils/lineHeight.js';

var fontsSort = ["Microsoft-YaHei", "SimSun", "SimHei", "KaiTi", "FangSong", "Arial", "sans-serif"];
Quill.imports['attributors/style/font'].whitelist = fontsSort;
Quill.register(Quill.imports['attributors/style/font'])

var fontSize = ['10px', '12px', '14px', '16px', '20px', '24px', '36px']
Quill.imports['attributors/style/size'].whitelist = fontSize;
Quill.register(Quill.imports['attributors/style/size'])

Quill.register('modules/imageResize', ImageResize);
Quill.register({ 'formats/lineHeight': lineHeightStyle }, true)
Quill.register({ 'formats/letterSpacing': letterSpacingStyle }, true)

async function setupApp() {
  setupLoading();

  setupNProgress();

  setupIconifyOffline();

  setupDayjs();

  // 设置全局错误处理
  setupGlobalErrorHandler();

  const app = createApp(App);

  // 设置Vue组件错误处理
  app.config.errorHandler = handleComponentError;

  setupStore(app);

  await setupRouter(app);
  setupI18n(app);

  setupAppVersionNotification();

  app.mount('#app');
}

setupApp();
